// Lib
import React, { ReactElement } from 'react';

// Components
import TiptapToggleMarkTool from './TiptapToggleMarkTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

const TiptapBoldTool = (props: ToolbarToolProps): ReactElement => <TiptapToggleMarkTool {...props} mark="bold" />;

export default TiptapBoldTool;
